class CustomPagination extends HTMLElement {
  constructor() {
    super();
    this.initPages();
  }
  initPages() {
    var container = this;
    this.querySelector('.js-load-more').addEventListener('click', function(e){
      e.preventDefault();
      var $this = this,
          totalPages = container.querySelector('input[data-total-pages]').value,
          currentPage = container.querySelector('input[data-current-page]').value,
          nextUrl = container.querySelector('input[data-next-url]').value;

      $this.setAttribute('disabled', true);
      $this.querySelector('[load-more-text]').classList.add('hide');
      $this.querySelector('[loader]').classList.remove('hide');

      container.querySelector('[data-current-page]').value = currentPage;
      fetch(nextUrl)
      .then((response) => {
        return response.text();
      })
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        var orderContent = html.getElementById('blog-articles');
        document.getElementById('blog-articles').innerHTML += orderContent.innerHTML;
        var pagination = html.getElementById('pagination');
        document.getElementById('pagination').innerHTML = pagination.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
    });
  }
}

customElements.define('custom-pagination-list', CustomPagination);